<template>
  <ArtisanGrid ref="recordInfo" metaKey="JyRecordInfo">
    <template #status="{ row, label }">
      <el-tag :type="statusType[row.status]" effect="dark" size="small">
        {{ label }}
      </el-tag>
    </template>
    <template #timespan="{ row }">
      <span>{{ row.startPoint }}-{{ row.endPoint }}</span>
    </template>
  </ArtisanGrid>
</template>

<script>
export default {
  data() {
    return {
      statusType: {
        ok: "parimry",
        cancel: "warning",
        take: "success",
        stop: "info",
        undo: "danger",
      },
      isShow: false,
      recordId: "",
      title: "",
    };
  },
};
</script>

<style>
</style>